import { Card, CardBody, CardHeader } from "reactstrap";

const RobotControl = () => {


  return (
    <>
      <Card>
        <CardHeader>Robot Control</CardHeader>
        <CardBody className="pb-0">
          
        </CardBody>
      </Card>
    </>
  );
};

export default RobotControl;
